import * as Yup from 'yup'
import moment from 'moment';

const mustBeANumber = 'Must be a `number`.';
const requiredFieldText = 'This field is required';

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const expiryValidation = Yup.number().required(requiredFieldText).test("expirationm", "Expiration date must be in the future.", function () {
  let { card_expMonth, card_expYear } = this.parent;
  let curMonth = moment().month();
  let curYear = moment().year();
  if (parseInt(card_expYear) > curYear) return true;
  if (parseInt(card_expMonth) >= (curMonth + 1)) return true;
  return false;
});

function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }
  return value;
}

export const UserInfo1Schema = Yup.object().shape({
  firstName: Yup.string().required(requiredFieldText),
  lastName: Yup.string().required(requiredFieldText),
  email: Yup.string().ensure().email('Email address is not valid').required(requiredFieldText),
  phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required(requiredFieldText)
});

export const BlueSwipeCustomerBillingFormSchema = Yup.object().shape({
  firstName: Yup.string().required(requiredFieldText),
  lastName: Yup.string().required(requiredFieldText),
  address: Yup.object().shape({
    address1: Yup.string().required(requiredFieldText),
    zip: Yup.number(mustBeANumber).transform(emptyStringToNull).nullable(true).required(requiredFieldText),
    city: Yup.string().required(requiredFieldText),
    state: Yup.string().required(requiredFieldText)
  })
});

export const BlueSwipeCustomerCardSchema = Yup.object().shape({
  card_number: Yup.number().required(requiredFieldText),
  card_expMonth: expiryValidation,
  card_expYear: expiryValidation,
  card_cvv: Yup.string().matches(/^\d+$/, {
    message: mustBeANumber
  }).required(requiredFieldText)
});

export const BlueSwipeIndAccountBillingFormSchema = Yup.object().shape({
  firstName: Yup.string().required(requiredFieldText),
  lastName: Yup.string().required(requiredFieldText),
  address: Yup.object().shape({
    address1: Yup.string().required(requiredFieldText),
    zip: Yup.number(mustBeANumber).transform(emptyStringToNull).nullable(true).required(requiredFieldText),
    city: Yup.string().required(requiredFieldText),
    state: Yup.string().required(requiredFieldText)
  })
});

export const BlueSwipeBusAccountBillingFormSchema = Yup.object().shape({
  businessName: Yup.string().required(requiredFieldText),
  tin: Yup.number().required(requiredFieldText),
  firstName: Yup.string().required(requiredFieldText),
  lastName: Yup.string().required(requiredFieldText),
  address: Yup.object().shape({
    address1: Yup.string().required(requiredFieldText),
    zip: Yup.number(mustBeANumber).transform(emptyStringToNull).nullable(true).required(requiredFieldText),
    city: Yup.string().required(requiredFieldText),
    state: Yup.string().required(requiredFieldText)
  })
});

export const BlueSwipeAccountFormSchema = Yup.object().shape({
  bnk_accountNumber: Yup.number().required(requiredFieldText),
  bnk_routingNumber: Yup.number().required(requiredFieldText)
});
